'use client';

import * as React from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { TOUR_PARAM } from '@/shared/lib/tours/registry';
import { startTour } from '@/shared/lib/tours/tour-store';

/**
 * `?tour=<id>` → start that tour, then drop the param so a refresh or a shared
 * link doesn't replay it. Unknown ids are ignored (a link published before its
 * tour deployed just opens the page). Renders nothing; lives in the auth-only
 * Suspense block of platform-shell because it reads search params.
 */
export function TourLinkWatcher() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const requested = searchParams.get(TOUR_PARAM);

  React.useEffect(() => {
    if (!requested) return;
    startTour(requested, 'link');
    const rest = new URLSearchParams(searchParams.toString());
    rest.delete(TOUR_PARAM);
    const query = rest.toString();
    router.replace(query ? `${pathname}?${query}` : pathname, { scroll: false });
  }, [pathname, requested, router, searchParams]);

  return null;
}
